<template>
  <div id="userConfig">
    <van-action-sheet
      v-model="showSecurities"
      :actions="actions"
      @select="onSelect"
    />
    <div class="title">
      <span>{{ pageTitle }}</span>
      <img
        class="returns"
        src="@/assets/img/backleftarrow.png"
        alt=""
        @click="goBack()"
      />
    </div>

    <div class="form-wrapper">
      <!-- 券商选择字段 -->
      <div class="form-item">
        <div class="form-item-label">
          <span style="color: red" class="form-item-required">*</span>
          <span>券商</span>
        </div>
        <van-field
          v-model="form.securitiesName"
          type="text"
          label=""
          clearable
          readonly
          placeholder="请选择券商"
          @click="selectSecurities()"
        >
          <van-icon
            slot="right-icon"
            name="arrow-down"
            @click="selectSecurities()"
          />
        </van-field>
      </div>

      <!-- 券商账号字段 -->
      <div class="form-item">
        <div class="form-item-label">
          <span style="color: red" class="form-item-required">*</span>
          <span>券商账号</span>
        </div>
        <van-field
          v-model="form.securitiesAccount"
          label=""
          name="securitiesAccount"
          placeholder="请输入至少6位券商账号"
        />
      </div>

      <!-- 交易密码字段 -->
      <div class="form-item">
        <div class="form-item-label">
          <span style="color: red" class="form-item-required">*</span>
          <span>券商交易密码</span>
        </div>
        <van-field
          type="password"
          v-model="form.securitiesPassword"
          label=""
          name="securitiesPassword"
          placeholder="请输入至少6位券商交易密码"
        />
      </div>

      <!-- 通信密码字段，非必填，v-if="needCpass"-->
      <!-- <div class="form-item" v-if="needCpass"> -->
      <div class="form-item">
        <div class="form-item-label">
          <!-- <span style="color: red" class="form-item-required">*</span> -->
          <span style="color: red" class="form-item-not-required"></span>
          <span>券商通信密码</span>
        </div>
        <van-field
          type="password"
          v-model="form.securitiesCpass"
          label=""
          name="securitiesCPass"
          placeholder="请输入通信密码"
        />
      </div>
    </div>
    <div class="bottom-action" :class="{ 'border-top': showBorderTop }">
      <!-- 授权确认 -->
      <van-checkbox
        shape="square"
        checked-color="#229652"
        v-model="form.authorizeStatus"
        >授权使用该账户订阅的投顾策略跟单交易</van-checkbox
      >
      <!-- <van-checkbox shape="square" v-model="form.agreeStatus"
          >我已阅读并同意<span class="highlight">使用协议</span></van-checkbox
        > -->

      <!-- 提交按钮 -->
      <div class="submit-button">
        <van-button
          size="large"
          type="primary"
          block
          :disabled="disabledSubmit"
          :color="disabledSubmit ? '#00000066' : '#000'"
          @click="onSubmit"
          >提交</van-button
        >
      </div>
    </div>
    <status-popup
      v-model="statusPopupVisible"
      :type="statusPopupType"
      :title="statusPopupTitle"
      :description="statusPopupDescription"
      :autoClose="autoClose"
      :showConfirmButton="showStatusPopupConfirmButton"
      :showCancelButton="showStatusPopupCancelButton"
      :confirmText="statusPopupConfirmButtonText"
      :cancelText="statusPopupCancelButtonText"
      @confirm="onStatusPopupConfirm"
      @cancel="onStatusPopupClose"
    />
    <!-- 通知弹窗 -->
    <notification-popup
      v-model="showNotificationPopup"
      :title="notificationTitle"
      @confirm="handleNotificationConfirm"
      confirm-text="我知道了"
      :content="notificationContent"
    />
  </div>
</template>
<script>
import Vue from "vue";
import StatusPopup from "@/components/StatusPopup.vue";
import NotificationPopup from "@/components/NotificationPopup.vue";
import {
  Form,
  Field,
  Picker,
  ActionSheet,
  Checkbox,
  Toast,
  // Popup,
} from "vant";
import {
  islogin,
  fetchSecurities,
  setUserSecuritiesInfo,
  fetchUserIndentity,
  updateUserVisitStatus,
} from "@/api/theApi";
export default {
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [ActionSheet.name]: ActionSheet,
    [Checkbox.name]: Checkbox,
    StatusPopup,
    NotificationPopup,
  },
  data() {
    return {
      showNotificationPopup: false,
      notificationTitle: "签约投顾服务通知",
      notificationContent:
        "您的签约将在1-2个工作日完成，完成后将短信通知您签约状态。",
      statusPopupVisible: false,
      statusPopupType: "",
      statusPopupTitle: "",
      statusPopupDescription: "",
      showStatusPopupConfirmButton: false,
      showStatusPopupCancelButton: false,
      statusPopupConfirmButtonText: "",
      statusPopupCancelButtonText: "",
      autoClose: 3000,
      // 登录状态
      islogin: false,
      pageTitle: "AI 大模型交易助手",
      showSecurities: false,
      disabledSubmit: true,
      showBorderTop: false,
      // needCpass: false,   // securities.requireFileds === 1 时展示
      needCpass: true,
      actions: [],
      form: {
        // phoneNumber: "",
        securitiesName: "",
        securitiesId: "",
        securitiesAccount: "",
        securitiesPassword: "",
        securitiesCpass: "",
        authorizeStatus: false,
        // agreeStatus: false,
      },
      userInfo: {},
    };
  },
  async created() {
    await this.init();
  },
  mounted() {
    // 检查滚动条，设置 bottom button 样式
    this.getScrollStatus();
  },
  watch: {
    form: {
      handler(newVal) {
        const validateResult = this.validateFullfilled(newVal);
        if (validateResult) {
          this.disabledSubmit = false;
        } else {
          this.disabledSubmit = true;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getScrollStatus() {
      const parent = this.$el.querySelector("#userConfig");
      const child = this.$el.querySelector(".form-wrapper");
      const hasVerticalScrollbar = child.scrollHeight > child.clientHeight;
      if (hasVerticalScrollbar) {
        this.showBorderTop = true;
      } else {
        this.showBorderTop = false;
      }
    },
    goBack() {
      try {
        if (this.$router) {
          this.$router.go(-1);
        }
      } catch (error) {
        console.warn("路由跳转异常:", error);
      }
    },
    onStatusPopupConfirm() {
      this.showNotificationPopup = true;
    },
    onStatusPopupClose() {
      this.statusPopupVisible = false;
    },
    showStatusPopup(
      type,
      title,
      description,
      autoClose = 3000,
      showStatusPopupConfirmButton = false,
      showStatusPopupCancelButton = false,
      statusPopupConfirmButtonText = "立即前往",
      statusPopupCancelButtonText = "暂不前往"
    ) {
      this.statusPopupType = type;
      this.statusPopupTitle = title;
      this.statusPopupDescription = description;
      this.showStatusPopupConfirmButton = showStatusPopupConfirmButton;
      this.showStatusPopupCancelButton = showStatusPopupCancelButton;
      this.statusPopupConfirmButtonText = statusPopupConfirmButtonText;
      this.statusPopupCancelButtonText = statusPopupCancelButtonText;
      this.autoClose = autoClose;
      this.statusPopupVisible = true;
    },
    async handleNotificationConfirm() {
      this.showNotificationPopup = false;
      await updateUserVisitStatus({uid: localStorage.getItem("username"), type: 8});
      location.href = this.userInfo.investAgencyURL;
    },
    async init() {
      // 登录是否过期
      const theislogin = await islogin();
      this.islogin = theislogin.login_status;

      if (!theislogin.login_status) {
        Toast.fail("您已退出\n请重新登录");
        setTimeout(() => {
          this.$router.push({
            path: "/login",
          });
        }, 2000);
      }

      const username = localStorage.getItem("username");
      // 获取券商列表
      const securities = await fetchSecurities();
      this.securities = securities;
      const actions = await securities.data;
      this.actions = actions.filter((item) => {
        return item.id !== 2;
      });

      // 获取用户已配置的券商信息
      const uinfoOfSecuritiesRes = await fetchUserIndentity(username);
      this.userInfo = uinfoOfSecuritiesRes.data;
      let uinfoOfSecurities = uinfoOfSecuritiesRes.data;

      // 修改页面标题
      this.pageTitle = "编辑我的配置信息";
      // 表单回填
      this.form = {
        // phoneNumber: uinfoOfSecurities.securitiesSettingVo.securitiesPhone,
        securitiesName: uinfoOfSecurities.securitiesSettingVo.securitiesName,
        securitiesId: uinfoOfSecurities.securitiesSettingVo.securitiesId,
        securitiesAccount:
          uinfoOfSecurities.securitiesSettingVo.securitiesUsername,
        securitiesPassword:
          uinfoOfSecurities.securitiesSettingVo.securitiesPassword,
        securitiesCpass:
          uinfoOfSecurities.securitiesSettingVo.securitiesCommunicationPassword,
        authorizeStatus: true,
        // agreeStatus: true,
      };
    },
    onSelect(value) {
      this.showSecurities = false;
      this.form.securitiesId = value.id;
      this.form.securitiesName = value.name;
      // if (value.requireFileds === 1) {
      //   this.needCpass = true;
      // } else {
      //   this.needCpass = false;
      // }
      // 券商更改后，清除券商账号、交易密码、通信密码
      this.form.securitiesAccount = "";
      this.form.securitiesPassword = "";
      this.form.securitiesCpass = "";
    },
    selectSecurities() {
      this.showSecurities = true;
    },
    onBrokerConfirm(value) {
      this.broker = value;
    },
    async onSubmit() {
      const validateResult = this.validateForm();
      if (validateResult) {
        try {
          Toast.loading({
            message: "正在提交...",
            forbidClick: true,
          });

          const username = localStorage.getItem("username");
          const res = await setUserSecuritiesInfo({
            uid: username,
            securitiesId: this.form.securitiesId,
            securitiesUsername: this.form.securitiesAccount,
            securitiesPassword: this.form.securitiesPassword,
            securitiesCommunicationPassword: this.form.securitiesCpass,
          });
          if (res.code === 20000) {
            if (
              !this.userInfo.investAgencySignStatus ||
              this.userInfo.investAgencySignType === "2"
            ) {
              this.showStatusPopup(
                "success",
                "保存成功",
                "根据合规要求，需签约投顾服务后方可启用AI策略自动交易。",
                0,
                true,
                true,
                "去签约",
                "以后再说"
              );
            } else {
              this.showStatusPopup("success", "保存成功", "用户配置成功", 3000);
              setTimeout(() => {
                // 配置成功，清空表单
                this.form = {
                  // phoneNumber: "",
                  securitiesName: "",
                  securitiesId: "",
                  securitiesAccount: "",
                  securitiesPassword: "",
                  securitiesCpass: "",
                  authorizeStatus: false,
                  // agreeStatus: false,
                };
                try {
                  if (this.$router) {
                    this.$router.go(-1);
                  }
                } catch (error) {
                  console.warn("路由跳转异常:", error);
                }
              }, 2500);
            }
          } else {
            this.showStatusPopup("fail", "用户配置失败", res.msg, 3000);
            console.error("用户配置失败:", res.msg);
          }
        } catch (error) {
          console.error("用户配置失败:", error);
          this.showStatusPopup("fail", "用户配置失败", "用户配置失败，请稍后重试", 3000);
        }
      }
    },
    validateFullfilled(newVal) {
      let form = newVal;
      // 检查表单是否填完整
      let fullfilled = true;
      let filledForm = {};
      // if (this.needCpass) {
      //   filledForm = form;
      // } else {
      //   filledForm = {
      //     // phoneNumber: form.phoneNumber,
      //     securitiesName: form.securitiesName,
      //     securitiesId: form.securitiesId,
      //     securitiesAccount: form.securitiesAccount,
      //     securitiesPassword: form.securitiesPassword,
      //     authorizeStatus: form.authorizeStatus,
      //     // agreeStatus: form.agreeStatus,
      //   };
      // }
      filledForm = {
        // phoneNumber: form.phoneNumber,
        securitiesName: form.securitiesName,
        securitiesId: form.securitiesId,
        securitiesAccount: form.securitiesAccount,
        securitiesPassword: form.securitiesPassword,
        authorizeStatus: form.authorizeStatus,
        // agreeStatus: form.agreeStatus,
      };
      for (const field in filledForm) {
        if (!form[field]) {
          fullfilled = false;
        }
      }
      return fullfilled;
    },
    // 表单规则校验
    validateForm() {
      let validateResult = true;
      // if (!/^1\d{10}$/.test(this.form.phoneNumber)) {
      //   this.$toast("请输入有效的手机号");
      //   validateResult = false;
      // }
      if (!this.form.securitiesId) {
        this.$toast("请选择券商");
        validateResult = false;
      }
      if (
        !this.form.securitiesAccount ||
        this.form.securitiesAccount.length < 6
      ) {
        this.$toast("券商账号至少6位");
        validateResult = false;
      }
      if (
        !this.form.securitiesPassword ||
        this.form.securitiesPassword.length < 6
      ) {
        this.$toast("交易密码至少6位");
        validateResult = false;
      }
      // if (
      //   this.form.needCpass &&
      //   (!this.form.securitiesCpass || this.form.securitiesCpass.length < 6)
      // ) {
      //   this.$toast("通信密码至少6位");
      //   validateResult = false;
      // }
      if (
        this.form.securitiesCpass.length > 0 &&
        this.form.securitiesCpass.length < 6
      ) {
        this.$toast("通信密码至少6位");
        validateResult = false;
      }
      return validateResult;
    },
  },
};
</script>
<style lang="less" scoped>
#userConfig {
  background-color: #fff;
  height: 100vh;
}
.title {
  height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .returns {
    position: absolute;
    width: 24px;
    height: 24px;
    left: 16px;
  }
}
.form-wrapper {
  padding: 3px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: scroll;
  height: calc(100% - 190px);

  .form-item-label {
    padding-bottom: 4px;
    color: #1d2129;
    .form-item-required {
      padding-right: 8px;
    }
    .form-item-not-required {
      padding-right: 15px;
    }
  }
  .van-cell {
    background: #f2f3f5;
  }
}
.bottom-action {
  height: 128px;
  padding-inline: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  width: 100vw;
  bottom: 0;
  background: #fff;
  gap: 12px;
  .highlight {
    color: #8c5800;
  }
  .submit-button {
    margin-top: 8px;
    .van-button {
      border: none;
      border-radius: 100px;
      font-size: 16px;
      font-weight: 600 !important;
    }
  }
}
.bottom-action.border-top {
  border-top: 1px solid #0000001a;
}
</style>
